import Global from '@/global'
import Vue from 'vue'
import VueStorage from 'vue-ls'
import { CACHE_KEY } from './constant'

Vue.use(VueStorage, {
  name: 'ls',
  storage: 'local'
})

Vue.use({ ...VueStorage }, {
  name: 'ss',
  storage: 'session'
})

if (Vue.ls.get(CACHE_KEY.LS_VERSION) === null) {
  localStorage.clear()
  sessionStorage.clear()
  Vue.ls.set(CACHE_KEY.LS_VERSION, 1)
}

const counterCacheKey = CACHE_KEY.NAV_TAG_COUNTER
const refreshKey = CACHE_KEY.NAV_REFRESH_TIME
const logoutPageKey = CACHE_KEY.NAV_TAG_LOGOUT

const cacheRefreshTime = Vue.ls.get(refreshKey)

function isLoginPage() {
  return !Vue.ss.get(logoutPageKey)
}

// 超过2000秒则认为是之前关闭了页面
if (cacheRefreshTime !== null && Date.now() - cacheRefreshTime > 2000) {
  // 时间超出
  if (isLoginPage()) {
    resetStorage()
  }
}

let interval = -1

function stopInterval() {
  clearInterval(interval)
  interval = -1
}

Global.addPageVisibilityChangeEvent(() => {
  if (interval > -1) {
    stopInterval()
  }
}, () => {
  if (isLoginPage()) {
    Vue.ls.set(refreshKey, Date.now())
    interval = setInterval(() => {
      if (isLoginPage()) {
        Vue.ls.set(refreshKey, Date.now())
      } else {
        stopInterval()
      }
    }, 1900)
  }
})

function addNavTagCounter(num) {
  const counter = Vue.ls.get(counterCacheKey) || 0
  Vue.ls.set(counterCacheKey, counter + num)
}

function windowDestroyReset() {
  if (!Vue.ss.get(CACHE_KEY.NAV_TAG_LOGOUT)) {
    unloadReset()
  }
  Vue.ls.set(refreshKey, Date.now())
}

window.addEventListener('beforeunload', windowDestroyReset)

export function incrementNavTagCounter() {
  addNavTagCounter(1)
}

export function resetStorage() {
  Vue.ls.remove(counterCacheKey)
  Vue.ls.remove(CACHE_KEY.QUERY_COC_TAG_IDS)
  Vue.ls.remove(CACHE_KEY.QUERY_COC_CORP_IDS)
  Vue.ls.remove(CACHE_KEY.QUERY_COC_TIME_RANGE)
}

export function clearCurrentCache() {
  Vue.ls.remove(CACHE_KEY.HILEIA_USER_INFO)
  resetStorage()
}

export function unloadReset() {
  const counter = (Vue.ls.get(counterCacheKey) || 0) - 1 // 计数器减1
  if (counter < 0) {
    resetStorage()
  } else {
    Vue.ls.set(counterCacheKey, counter)
  }
}
